import { AppLink, cx } from "@amber/ui";
import type { DateConflictView } from "../../contracts/index";

export function DateConflictList({ conflicts, className }: { conflicts: DateConflictView[]; className?: string }) {
  if (conflicts.length === 0) return null;
  return (
    <ul aria-label="Date conflicts" className={cx("m-0 list-none p-0 text-attention", className)}>
      {conflicts.map((c) => (
        <li key={c.text}>
          {c.text}
          {c.task_id ? (
            <>
              {" · "}
              <AppLink href={`/tasks/${c.task_id}`} className="text-link underline">
                Review task
              </AppLink>
            </>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
